<template>
    <el-row style="margin-top: 100px;">
        <el-col :sm="24" :lg="6">
            <el-result icon="error" title="绑定失败" subTitle="点击左上角 x 号返回微信">
            </el-result>
        </el-col>
    </el-row>
</template>

<script>
    export default {
        name: "fail"
    }
</script>

<style scoped>

</style>
